// entrypoint.tsx

import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { EntryPointRouteParams } from '@atlassian/jira-entry-points-plugin/src/common/types.tsx';
import parameters from '@atlassian/jira-relay/src/__generated__/uiAdminPagesFieldsQuery$parameters';

// Backwards compatibility with old URL params
const CustomFieldStatus = {
	TRASHED: 'trashed',
	ACTIVE: 'active',
} as const;

type InitialTab = 'active' | 'deleted';

export const globalSettingsIssueFieldsManagementRouteEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "async-jira-admin-pages-fields-page" */ './src'),
	),
	getPreloadProps: ({ tenantContext: { cloudId }, context: { query } }: EntryPointRouteParams) => {
		const initialTab: InitialTab =
			query.customFieldStatus?.toLowerCase() === CustomFieldStatus.TRASHED ? 'deleted' : 'active';
		return {
			queries: {
				globalFields: {
					options: {
						fetchPolicy: 'network-only' as const,
					},
					parameters,
					variables: {
						cloudId,
					},
				},
			},
			extraProps: { initialTab },
		};
	},
});
